import { render, staticRenderFns } from "./Dress.vue?vue&type=template&id=f583570e&scoped=true&"
import script from "./Dress.vue?vue&type=script&lang=js&"
export * from "./Dress.vue?vue&type=script&lang=js&"
import style0 from "./Dress.vue?vue&type=style&index=0&id=f583570e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f583570e",
  null
  
)

export default component.exports